// extracted by mini-css-extract-plugin
export default {"name":"style_name__ObDK3","image":"style_image__LAIUb","singleImage":"style_singleImage__oCshF","sm":"style_sm__38FC8","lg":"style_lg__GL+qx","md":"style_md__0OLHh"};